// src/utils/apiClient.js
import axios from "axios";
import { API_BASE_URL } from "../confing.js/baseUrl";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000, // optional: 10s timeout
});

// Add interceptors if you need auth token, logging, etc.
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Centralize error handling
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
